/** Visual controls diagram shown while waiting for the game to load. */

import { isMobile } from "../lib/isMobile";
import lookIcon from "../assets/look.svg";
import speakIcon from "../assets/speak.svg";
import { LuMic, LuMousePointerClick } from "react-icons/lu";

export function ControlsDiagram() {
  return isMobile() ? <MobileControls /> : <DesktopControls />;
}

function DesktopControls() {
  return (
    <div className="pp-controls">
      <div className="pp-ctrl-grp">
        <div className="pp-icon-zone">
          <div className="pp-keys">
            <div className="pp-key-row"><div className="pp-key">W</div></div>
            <div className="pp-key-row"><div className="pp-key">A</div><div className="pp-key">S</div><div className="pp-key">D</div></div>
          </div>
        </div>
        <div className="pp-ctrl-label">Move</div>
      </div>
      <div className="pp-ctrl-grp">
        <div className="pp-icon-zone"><div className="pp-key">E</div></div>
        <div className="pp-ctrl-label">Interact</div>
      </div>
      <div className="pp-ctrl-grp">
        <div className="pp-icon-zone"><div className="pp-ctrl-icon"><img src={lookIcon} alt="Look" /></div></div>
        <div className="pp-ctrl-label">Look</div>
      </div>
      <div className="pp-ctrl-grp">
        <div className="pp-icon-zone"><div className="pp-ctrl-icon"><img src={speakIcon} alt="Speak" /></div></div>
        <div className="pp-ctrl-label">Speak</div>
      </div>
    </div>
  );
}

function MobileControls() {
  return (
    <div className="pp-mob-grid">
      <div className="pp-mob-ctrl">
        <div className="pp-mob-circle">
          <LuMousePointerClick style={{ width: 36, height: 36}} />
        </div>
        <div className="pp-mob-label">Interact</div>
      </div>
      <div className="pp-mob-ctrl">
        <div className="pp-mob-circle">
          <LuMic style={{ width: 36, height: 36}} />
     
        </div>
        <div className="pp-mob-label">Speak</div>
      </div>
      <div className="pp-mob-ctrl">
        <div className="pp-mob-circle"><span className="pp-mob-letter">L</span></div>
        <div className="pp-mob-label">Move</div>
      </div>
      <div className="pp-mob-ctrl">
        <div className="pp-mob-circle"><span className="pp-mob-letter">R</span></div>
        <div className="pp-mob-label">Look</div>
      </div>
    </div>
  );
}
